import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { ItfEcoCartItem } from '../../type';
import getLocal from 'eco-design-reliance/getLocal';
import './index.scss';
import EcoCartCountdown from '../EcoCartCountdown';
import { EcoCartCouponCopy, EcoCartCouponGift } from '../EcoCartCoupon/icons';
import { useState } from 'react';
import ClipboardJS from 'clipboard';
import useEcoCart from '../../useEcoCart';
import { i18n } from '../../i18n';

const EcoCartFooterCoupon: React.FC = () => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;
    const { items, coupon } = useEcoCart();
    const [copyed, setCopyed] = useState<string>('');

    // @ts-ignore
    const clipboard = typeof window !== 'undefined' ? new ClipboardJS(`.eco-cart-footer .eco-cart-footer-gift-card .eco-cart-footer-gift-code`) : null;
    const copyText = () => {
        setCopyed(coupon?.code || '');
        const timer = setTimeout(() => {
            setCopyed('');
            if (timer) {
                clearTimeout(timer);
            }
        }, 3000);
    };

    return (
        <>
            {coupon && coupon.amount && (
                <>
                    <div className="eco-cart-footer-subtotal-price">
                        <span className="total">{t.cart_footer_subtotal}</span>
                        <span className="price">
                            {FormatMoneyLocal(
                                items.reduce((prev: number, cur: ItfEcoCartItem) => {
                                    return prev + (cur.price * 100 * (cur.quantity ?? 0)) / 100;
                                }, 0),
                                locale,
                            )}
                        </span>
                    </div>
                    <div className="eco-cart-footer-discount-price">
                        <span className="total">
                            {coupon.ruleType === 'COUPONS' ? t.cart_footer_discount : coupon.ruleType === 'GIFT_CARD' ? t.cart_footer_gift : ''}
                        </span>
                        {Number(coupon.discountAmount) > 0 && (
                            <span className="price">
                                {'-'}
                                {FormatMoneyLocal(Number(coupon.discountAmount), locale)}
                            </span>
                        )}
                    </div>
                    {coupon.ruleType === 'GIFT_CARD' && (
                        <div className="eco-cart-footer-gift-card">
                            <div className="eco-cart-footer-gift-code" onClick={copyText} data-clipboard-text={coupon.code}>
                                <div className="code-icon">{EcoCartCouponGift}</div>
                                <span className="code-text">{copyed ? t.cart_coupon_copied : `***${coupon.code?.slice(coupon.code?.length - 4)}`}</span>
                                <div className="code-icon icon-copy">{EcoCartCouponCopy}</div>
                            </div>
                            <p className="eco-cart-footer-gift-split"></p>
                            <EcoCartCountdown />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default EcoCartFooterCoupon;
